// English texts of the capture SDK. Same keys as `es.ts` (a test enforces it).
import type { MessageKey } from './es.js';

export const en: Record<MessageKey, string> = {
  'app.title': 'KYP capture',
  'app.close': 'Close',
  'app.error': 'Something went wrong. Please try again.',
  'app.retry': 'Try again',
  'app.next': 'Continue',
  'app.skip': 'Skip',
  'app.loading': 'One moment…',
  'step.permission': 'Camera',
  'step.label': 'Label',
  'step.challenge': 'Live challenge',
  'step.views': 'Views',
  'step.ruler': 'Size',
  'step.declarations': 'Details',
  'step.summary': 'Summary',
  'step.progress': 'Step {n} of {total}: {name}',
  'permission.title': "Let's photograph your parcel",
  'permission.body':
    'We use the live camera. Existing photos cannot be uploaded: this proves the parcel is in front of you right now.',
  'permission.button': 'Allow the camera',
  'permission.checking': 'Checking the camera…',
  'rejected.title': 'We cannot start the capture',
  'rejected.virtual_camera':
    'The camera looks virtual or software based. Please use the device’s real camera.',
  'rejected.settings_incoherent':
    'The camera reports an unusual configuration. Try another camera or another browser.',
  'rejected.getusermedia_patched':
    'Camera access has been modified by an extension or a script. Disable it and try again.',
  'rejected.flat_frame': 'The image is completely flat. Uncover the camera and try again.',
  'rejected.no_sensor_noise':
    'The image does not seem to come from a real sensor. Please use the device camera.',
  'rejected.no_frames': 'No images are coming from the camera. Please try again.',
  'rejected.no_camera': 'We could not find a camera on this device.',
  'rejected.permission_denied':
    'We cannot continue without camera permission. You can grant it in the browser settings.',
  'rejected.unsupported': 'This browser does not support live capture. Please try another browser.',
  'rejected.server': 'The server did not accept the capture session.',
  'label.title': 'Shipping label',
  'label.body': 'Frame the label inside the guide and press the button.',
  'label.detected': 'Code detected: {code}',
  'label.tracking': 'Tracking number',
  'label.shoot': 'Photograph the label',
  'challenge.title': 'Live challenge',
  'challenge.body':
    'The screen will change colour for a few seconds. Point at the parcel and slowly move around it.',
  'challenge.start': 'Start the challenge',
  'challenge.running': 'Slowly move around the parcel',
  'challenge.done': 'Challenge recorded',
  'views.title': 'View {n} of {total}: {name}',
  'views.front': 'front',
  'views.side': 'side',
  'views.top': 'top',
  'views.label_corner': 'corner with the label',
  'views.hint.front': 'Stand in front of the parcel and keep it fully in view.',
  'views.hint.side': 'Now one of the sides, fully inside the frame.',
  'views.hint.top': 'From above, with the whole top face.',
  'views.hint.label_corner': 'The corner with the label, with the label visible.',
  'views.shoot': 'Take photo',
  'views.shooting': 'Capturing…',
  'quality.dark': 'The photo is too dark.',
  'quality.blurry': 'The photo looks blurry.',
  'quality.retry': 'Retake',
  'quality.keep': 'Use anyway',
  'quality.ok': 'Photo saved.',
  'ruler.title': 'Size (optional)',
  'ruler.body':
    'If you print the KYP ruler and place it next to the parcel, we can estimate its size. Sizes you enter are stored as estimates.',
  'ruler.link': 'Open the KYP ruler (A4)',
  'ruler.estimated': 'Estimated size',
  'ruler.length': 'Length',
  'ruler.width': 'Width',
  'ruler.height': 'Height',
  'ruler.unit': 'Unit',
  'declarations.title': 'What you declare',
  'declarations.body': 'Optional. Stored as your declaration, never as a verified measurement.',
  'declarations.weight': 'Weight (grams)',
  'declarations.content': 'Contents',
  'declarations.tracking': 'Tracking number',
  'summary.title': 'Summary',
  'summary.body': 'We will sign the capture on this device and send it.',
  'summary.shots': 'Photos: {n}',
  'summary.video': 'Challenge video: {n} chunks',
  'summary.submit': 'Sign and send',
  'summary.uploading': 'Uploading {done} of {total}',
  'summary.stage.received': 'Received',
  'summary.stage.signed': 'Signed',
  'summary.stage.sealed': 'Sealed',
  'result.title': 'Capture sent',
  'result.level': 'Confidence level: {level}',
  'result.level.attested': 'attested',
  'result.level.signed': 'signed',
  'result.level.degraded': 'degraded',
  'result.level.rejected': 'rejected',
  'result.score': 'Score: {score}/100',
  'result.peid': 'Parcel identifier: {peid}',
  'result.verify': 'View the parcel document',
  'result.findings': 'Notes: {n}',
  'handoff.title': 'Continue on your phone',
  'handoff.body': 'Scan the QR code with your phone, or open the link and type the code.',
  'handoff.code': 'Code: {code}',
  'handoff.link': 'Link for the phone',
  'handoff.waiting': 'Waiting for the phone…',
  'handoff.opened': 'The phone has opened the capture.',
  'handoff.expired': 'The code has expired. Please start again.',
  'shutter.label': 'Take photo (Space or Enter)',
  'voice.on': 'Voice guidance on',
};
